import { Injectable } from '@angular/core';

@Injectable()
export class RaptorStepDataService {
  private data!: any;

  constructor() { }

  public set(data: any): void {
    this.data = data;
  }

  public setCovers(data: any) {
    this.data = this.data || {};
    this.data.covers = data;
  }

  public get(): any {
    return this.data;
  }
}
